// Body of the Oscar account-registration view: the legacy account-page layout
// — the brand heading, the ConvertLazyUserForm rendered as a native React
// field tree, the decorative account image, and the customer-service info
// block. The headings / submit label / block copy arrive pre-localized as
// props (server-side gettext, matching the legacy {% trans %} path under
// whatever LANGUAGES the site configures).
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import { duplicateEmailAfterField } from "tsi-common-react/src/forms/DuplicateEmailError/index";
import {
    FORM_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { AccountSplitShell } from "../AccountSplitShell";
import { CustomerServiceInfoBlock } from "../CustomerServiceInfoBlock";

type IProps = Immutable<templates.RegistrationDocumentTemplate>;

export const RegistrationBody = (props: IProps): React.JSX.Element => {
    return (
        <AccountSplitShell
            heading={props.page_copy?.page_heading}
            sectionHeading={props.page_copy?.section_heading}
            footer={
                props.cs_info && (
                    <CustomerServiceInfoBlock info={props.cs_info} />
                )
            }
        >
            <div>
                <form
                    className={concatClassNames([
                        FORM_CLASS_NAME,
                        "js-kuid-form",
                    ])}
                    method="post"
                    action={props.action_url}
                >
                    <CSRFToken />
                    <FormFields
                        fields={props.fields}
                        field_labels={props.field_labels}
                        field_errors={props.field_errors}
                        non_field_errors={props.non_field_errors}
                        afterField={duplicateEmailAfterField(props)}
                    />
                    <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                        <input
                            type="submit"
                            className="button button--full-width"
                            value={props.page_copy?.submit_text}
                        />
                    </div>
                </form>
            </div>
        </AccountSplitShell>
    );
};
